import { render } from "./ListFarmacias.vue?vue&type=template&id=2505ce2d"
import script from "./ListFarmacias.vue?vue&type=script&lang=js"
export * from "./ListFarmacias.vue?vue&type=script&lang=js"

import "./ListFarmacias.vue?vue&type=style&index=0&id=2505ce2d&lang=css"

import exportComponent from "/Users/robo1/Documents/Admin/campanha-pedido/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__